<header class="mobile-header" [class.show-signers]="isShowingSignersMobile || isShowingHistoryMobile" *ngIf="document && urlParamsService.params.mobileNavigation">
  <a routerLink="/" class="header-brand" *ngIf="!isShowingSignersMobile && !isShowingHistoryMobile">
    <img [src]="documentWhitelabel.pdf_logo_mini" alt="" />
  </a>
  @if (isShowingSignersMobile) {
    <a class="btn-M btn-text icon-start" (click)="isShowingSignersMobile = false; checkScrollingRequiredMobile()">
      <i class="fal fa-chevron-left"></i>
      {{ 'button.back' | translate }}
    </a>
  }
  @if (isShowingHistoryMobile) {
    <a class="btn-M btn-text icon-start" (click)="isShowingHistoryMobile = false; checkScrollingRequiredMobile()">
      <i class="fal fa-chevron-left"></i>
      {{ 'button.back' | translate }}
    </a>
  }
  <span class="mobile-header__title" *ngIf="isShowingSignersMobile">{{ 'documents.signatories' | translate }}</span>
  <span class="mobile-header__title" *ngIf="isShowingHistoryMobile">{{ 'documents.history' | translate }}</span>
  <ng-container [ngTemplateOutlet]="documentDropdownTemplateMobile" *ngIf="document"></ng-container>
</header>

<ng-template #signersTemplate>
  <div
    *ngFor="let signer of document?.signatures | sortByCurrentSigners: document : currentSigners; let index = index"
    class="sidebar-signers-item"
    [class.pending]="document.sortable && index > documentService.getNextSignerIndex(document)"
    [class.to-sign-target]="document.sortable ? documentService.isSignerTurn(document, signer) : isCurrentSigner(signer)"
  >
    <div class="sidebar-signers-order" *ngIf="document.sortable">
      <div class="sidebar-signers-order--num">{{ index + 1 }}</div>
    </div>
    <app-signer-card
      [signer]="signer"
      [sortable]="document.sortable"
      [isAllowedUser]="isAdmin() || isAutnq()"
      [isSignerTurn]="documentService.isSignerTurn(document, signer)"
      [forceAvatar]="document?.signatures.length > 20"
      [documentAuthorId]="document.author.id"
      [isMarkdownDocument]="documentService.isMarkdownDocument(document)"
      [hideBirthdate]="document.ignore_birthdate"
      [hideCPF]="document.ignore_cpf"
      [isDynamicDocument]="document?.is_dynamic_document"
      [signerHasFields]="verifySignerHasFields(signer)"
      [isCountryBR]="document?.locale?.country === 'BR'"
      [canValidateBiometry]="!!currentUser?.currentPermissions?.validate_biometry"
      (updateClick)="openUpdateSignerModal($event)"
      (deleteClick)="deleteSigner($event)"
      (createLinkClick)="openSignLinkModal($event)"
      (consultCPFClick)="openConsultCPFModal($event)"
      (resendSignaturesClick)="resendSignatures($event)"
      (verifyBiometryClick)="openVerificationDataModal($event)"
    >
    </app-signer-card>
  </div>
</ng-template>

<div [ngClass]="{ darkmode: documentWhitelabel.is_darkmode }">
  <div
    class="body-holder"
    [class.to-sign]="
      (documentService.isSignatureByLink(route.snapshot.params.id) || isSignaturePage()) && currentSigners[0] && documentService.isSignerPending(currentSigners[0], { ignoreEmailErrors: true })
    "
  >
    <aside class="sidebar">
      <app-document-sidebar-header [sessionBehavior]="currentSigners[0]?.configs?.session_behavior">
        @if (!enterpriseService.hideDocumentBackButton() && !isSigningPurpose()) {
          <a class="btn-M btn-text icon-start" [routerLink]="urlParamsService.params.mainPath || backLink">
            <i class="fal fa-chevron-left"></i>
            {{ backButtonLabel() }}
          </a>
        }
      </app-document-sidebar-header>
      <main class="sidebar__wrapper" [class.d-none]="showFieldsForm">
        <div class="monster__tabs">
          <button type="button" class="tab__item" (click)="changeSidebarContainer('signers')" [ngClass]="{ active: sidebarContainer === 'signers' }">
            <i class="far fa-signature"></i>
            {{ 'documents.signatories' | translate }}
          </button>

          <button type="button" class="tab__item" (click)="changeSidebarContainer('history')" [ngClass]="{ active: sidebarContainer === 'history' }">
            <i class="far fa-list-ul"></i>
            {{ 'documents.history' | translate }}
          </button>
        </div>

        <p class="sortable-alert" *ngIf="document?.sortable && sidebarContainer === 'signers'"><i class="fal fa-info-circle"></i> {{ 'documents.specificOrder' | translate }}</p>
        <div class="sidebar-signers-list" [class.height-for-qualified]="document?.sortable" *ngIf="sidebarContainer === 'signers'">
          <ng-container [ngTemplateOutlet]="signersTemplate"></ng-container>
        </div>
        <app-document-history-sidebar
          [class.d-none]="sidebarContainer !== 'history'"
          [lockUserData]="document?.configs.lock_user_data"
          [isMarkdownDocument]="documentService.isMarkdownDocument(document)"
          [signersFields]="signersFieldsData"
          #historyComponent
        ></app-document-history-sidebar>
      </main>

      <main class="sidebar__wrapper sidebar__wrapper--is-dynamic_document" [class.d-none]="!showFieldsForm || isMobile">
        <app-fill-dynamic-document-form
          [dateFormat]="document?.locale?.date_format"
          [currentSigner]="currentSigners[0]"
          [fieldsToFill]="fieldsToFill"
          [disabled]="isLoading"
          [context]="InlineFieldContext.FillSigner"
          (submitFields)="submitFilledFields($event)"
        ></app-fill-dynamic-document-form>
      </main>
    </aside>
    <div class="mobile-signers-list" *ngIf="isShowingSignersMobile">
      <ng-container [ngTemplateOutlet]="signersTemplate"></ng-container>
    </div>
    <div class="mobile-signers-list" [class.d-none]="!isShowingHistoryMobile">
      <app-document-history-sidebar
        [lockUserData]="document?.configs.lock_user_data"
        [isMarkdownDocument]="documentService.isMarkdownDocument(document)"
        [signersFields]="signersFieldsData"
        #historyComponentMobile
      ></app-document-history-sidebar>
    </div>

    <div class="mobile-fields-form" [class.d-none]="!showFieldsForm || !isMobile">
      <app-fill-dynamic-document-form
        [dateFormat]="document?.locale?.date_format"
        [currentSigner]="currentSigners[0]"
        [fieldsToFill]="fieldsToFill"
        (submitFields)="submitFilledFields($event)"
      ></app-fill-dynamic-document-form>
    </div>
    <section class="document" [class.d-none]="isShowingSignersMobile || isShowingHistoryMobile">
      <div class="document-warning" *ngIf="document?.is_blocked">
        <div class="document-warning-title"><i class="fal fa-exclamation-triangle"></i>&nbsp; {{ 'audit.securityNotice' | translate }}</div>
        <div class="document-warning-descr">
          {{ 'audit.thisDocumentHasBeenBlockedDueToFraudSuspicion' | translate }}<br />
          {{ 'audit.forMoreInformationContactUsAt' | translate }} <a href="mailto:contato@autentique.com.br">contato&#64;autentique.com.br</a>
        </div>
      </div>
      <div class="document-sandbox" *ngIf="document?.sandbox">
        <div class="document-sandbox-title">{{ 'audit.sandboxTestDocument' | translate }}</div>
        <div class="document-sandbox-descr">{{ 'audit.thisDocumentWasCreatedAsASandboxTestAndHasNoLegalValue' | translate }}</div>
      </div>

      <div class="document-head" *ngIf="document" [class.d-none]="showFieldsForm || mobileReview">
        <h2 class="document-head-name">{{ document.name }}</h2>
        <p class="document-head-date">
          {{ 'documents.createdOn' | translate: { date: document.created_at | dateTime: 'mediumDate' } }}
          <span *ngIf="document.expiration_at">
            ({{ 'documents.' + (documentService.isExpired(document) ? 'expiredOn' : 'expiresOn') | translate: { date: document.expiration_at | ldate: 'mediumDate' } }})
          </span>
        </p>
        <div class="document-head-attributes" *ngIf="isAdmin()">
          <div class="document-head-attributes--item" *ngIf="document.reminder">{{ 'documents.reminder.' + (document.reminder | lowercase) | translate }}</div>
          <div class="document-head-attributes--item" *ngIf="document.is_from_api">{{ 'documents.api' | translate }}</div>
          <div class="document-head-attributes--item" *ngIf="document.sortable">{{ 'documents.signatureOrder' | translate }}</div>
          <div class="document-head-attributes--item has-tooltip" *ngIf="document.cc && document.cc.length > 0" [ngbTooltip]="ccTooltip" placement="bottom">{{ 'documents.ccs' | translate }}</div>
          <div class="document-head-attributes--item" *ngIf="document.refusable">{{ 'documents.allowRefusal' | translate }}</div>
          <div class="document-head-attributes--item" *ngIf="document.qualified">{{ 'documents.qualifiedSignature' | translate }}</div>
          <div class="document-head-attributes--item" *ngIf="floatingFields && floatingFields.length > 0">{{ 'documents.visibleFields' | translate }}</div>
          <div class="document-head-attributes--item" *ngIf="document.configs?.lock_user_data">{{ 'documents.outdatedData' | translate }}</div>
          <div class="document-head-attributes--item" *ngIf="document.locale?.language && isAutnq">{{ 'language.' + document.locale?.language.toLocaleLowerCase() | translate | lowercase }}</div>
          <div class="document-head-attributes--item" *ngIf="document.locale?.country && isAutnq">{{ 'countryCodes.' + document.locale?.country.toLocaleLowerCase() | translate | lowercase }}</div>
          <div class="document-head-attributes--item" *ngIf="document.configs?.pdfa">PDF/A</div>

          <ng-template #ccTooltip>
            <div class="tooltip__descr" *ngFor="let item of document.cc">{{ item }}</div>
          </ng-template>
        </div>
        <ng-container [ngTemplateOutlet]="documentDropdownTemplate" *ngIf="document"></ng-container>
      </div>

      @if (!documentService.isMarkdownDocument(document) && !document?.is_dynamic_document) {
        <app-pdf-viewer
          [pdfUrl]="!documentService.isPastLifecycle(document) && document?.files?.original"
          [iframePdfUrl]="documentService.isSignedOnce(document) ? (document.qualified ? documentService.padesDocumentUrl(document) : documentService.signedDocumentUrl(document)) : null"
          [isNewSignatureStyle]="document?.new_signature_style"
          [documentFooter]="document?.new_signature_style && document?.footer"
          [documentFooterType]="document?.new_signature_style && document?.footer_type"
          [floatingFields]="floatingFields"
          [document]="document"
          [documentWhitelabel]="documentWhitelabel"
          [isDocumentWhitelabelLoaded]="isDocumentWhitelabelLoaded"
          [canRenderOnIframe]="!isMobile"
          [class.d-none]="documentService.isPastLifecycle(document) || showFieldsForm || mobileReview"
          #pdfViewer
        >
        </app-pdf-viewer>
      } @else if (document?.is_dynamic_document) {
        <div class="document-head" [class.d-none]="!showFieldsForm && (!isMobile || !mobileReview)">
          <h2 class="document-head-title">{{ 'documents.fieldsReview.title' | translate }}</h2>
          <p class="document-head-description">{{ 'documents.fieldsReview.description' | translate }}</p>
        </div>

        <app-dynamic-document-viewer
          #renderedTemplate
          [content]="documentHTML"
          [theme]="dynamicDocumentTheme"
          [scale]="renderedDocumentScale"
          [context]="InlineFieldContext.FillSigner"
          [alreadyFilledFields]="alreadyFilledFields"
          (recalculateScale)="updateRenderedDocumentScale()"
        ></app-dynamic-document-viewer>

        @if ((fieldsToFill?.length > 0 || mobileReview) && isMobile) {
          <div
            class="document-rendered__gradient"
            [ngStyle]="{
              background: 'linear-gradient(180deg, rgba(4, 97, 255, 0) 0%, ' + documentWhitelabel.main_color + ' 100%)'
            }"
          ></div>
        }
      } @else if (documentService.isMarkdownDocument(document)) {
        <app-markdown-handler [markdownUrl]="document?.files.original"></app-markdown-handler>
      }

      @if (documentService.isPastLifecycle(document)) {
        <app-document-lifecycle-warning [(document)]="document"></app-document-lifecycle-warning>
      }

      @if (
        (canBeSigned() || (fieldsToFill && fieldsToFill.length > 0)) && (pdfViewer?.pagesCount() > 0 || documentHTML || documentService.isMarkdownDocument(document)) && isDocumentWhitelabelLoaded
      ) {
        <div class="document-action-holder">
          @if (document.refusable && documentService.isSignerTurn(document, currentSigners[0]) && currentSigners[0]?.action) {
            <button
              type="button"
              class="document-action"
              [ngClass]="scrollingRequired() ? 'scroll-action' : 'refuse'"
              [disabled]="isLoading || scrollingRequired()"
              (click)="rejectDocumentPrompt()"
              [class.d-none]="mobileReview"
            >
              {{ 'button.reject' | translate }}
            </button>
          }
          @if (documentService.isSignerTurn(document, currentSigners[0]) && isDocumentWhitelabelLoaded) {
            <button
              type="button"
              class="document-action"
              [ngStyle]="{
                backgroundColor: documentWhitelabel.main_color,
                boxShadow: '0 5px 25px ' + documentWhitelabel.main_color,
                color: appService.getContrastColor(documentWhitelabel.main_color)
              }"
              [ngClass]="scrollingRequired() ? 'scroll-action' : ''"
              [disabled]="isLoading || scrollingRequired()"
              (click)="signDocumentPrompt()"
              [class.d-none]="showFieldsForm || mobileReview || !fieldsToFill"
            >
              {{ appService.getActionButtonText(currentSigners[0], fieldsToFill?.length > 0) }}

              <div class="forceDefaultColors mini-tooltip">{{ 'signature.proceed' | translate }}</div>
            </button>

            <button type="button" class="document-action document-action--custom-back" (click)="showFieldsForm = true; mobileReview = false" [class.d-none]="!mobileReview">
              {{ 'button.back' | translate }}
            </button>

            <button
              type="button"
              class="document-action document-action--custom-forward"
              (click)="signDocumentPrompt()"
              [class.d-none]="!mobileReview"
              [ngStyle]="{
                backgroundColor: documentWhitelabel.main_color,
                color: appService.getContrastColor(documentWhitelabel.main_color)
              }"
            >
              {{ (!!currentSigners[0]?.action ? 'signature.signAction.' + (this.currentSigners[0]?.action.name.toLowerCase() || 'sign') : 'signature.signAction.fill') | translate }}

              <div class="forceDefaultColors mini-tooltip">{{ 'signature.proceed' | translate }}</div>
            </button>
          }
          <div [ngClass]="scrollingRequired() ? 'scroll-warning' : 'd-none'">
            {{ 'documents.viewDocumentBeforeSigning' | translate }}
          </div>

          @if (!documentService.isSignerTurn(document, currentSigners[0])) {
            <button type="button" class="document-action wait" disabled>{{ 'documents.notYourTurnToSignYet' | translate }}</button>
          }
        </div>
      }
      @if (needsElectronLogin() && (pdfViewer?.pagesCount() > 0 || documentService.isMarkdownDocument(document))) {
        <div class="document-action-holder">
          <button type="button" class="document-action" (click)="redirectToLogin()">{{ 'documents.login' | translate }}</button>
        </div>
      }
    </section>
  </div>
</div>

<ng-template #documentDropdownTemplate let-isMobile="isMobile">
  <div appDropdown placement="bottom-right">
    @if (isMobile) {
      <label id="document-dropdown-1" appDropdownToggle>
        <i class="fal fa-bars"></i>
      </label>
    } @else {
      @if (isAdmin()) {
        <button id="document-dropdown-2" type="button" class="dropdown__toggle-control dropdown__toggle-control--icon-end" appDropdownToggle>
          <span>{{ 'documents.options' | translate }}</span>
          <i class="far fa-ellipsis-v"></i>
        </button>
      } @else {
        <button id="document-dropdown-2" type="button" class="dropdown__toggle-control dropdown__toggle-control--icon-only" appDropdownToggle>
          <i class="far fa-ellipsis-v"></i>
        </button>
      }
    }

    <div [attr.aria-labelledby]="isMobile ? 'document-dropdown-1' : 'document-dropdown-2'" appDropdownMenu>
      @if (isMobile) {
        <button type="button" (click)="isShowingSignersMobile = true; changeSidebarContainer('signers')" appDropdownItem>
          <i class="fa-regular fa-feather-alt"></i> {{ 'documents.signatories' | translate }}
        </button>
        <button type="button" (click)="isShowingHistoryMobile = true; changeSidebarContainer('history')" appDropdownItem><i class="fal fa-history"></i> {{ 'documents.history' | translate }}</button>
      }
      <button type="button" appDropdownItem submenuToggle="document-dropdown-submenu1" aria-labelledby="document-dropdown-submenu1" [disabled]="documentService.isPastLifecycle(document)">
        <i class="fa-regular fa-cloud-download-alt"></i> {{ 'documents.downloadFile' | translate }}
      </button>
      @if (isAdmin() || isAutnq()) {
        <button type="button" (click)="$any($event.target).classList.add('disabled'); resendSignatures()" appDropdownItem>
          <i class="fa-regular fa-redo"></i> {{ 'documents.resendToSignatories' | translate }}
        </button>
      }
      @if (isAdmin()) {
        <button type="button" appDropdownItem submenuToggle="document-dropdown-submenu3" aria-labelledby="document-dropdown-submenu3">
          <i class="fa-regular fa-edit"></i> {{ 'documents.change' | translate }}
        </button>
      }
      @if (!document?.is_dynamic_document || isAdmin()) {
        <hr class="dropdown-divider" />
      }
      @if (isAdmin() || isAutnq()) {
        <button type="button" (click)="clearPdfCache()" appDropdownItem><i class="fa-regular fa-sync"></i>{{ 'documents.syncPDFData' | translate }}</button>
      }
      @if ((isAdmin() && documentService.isAllowedToResendWebhook(currentUser, document)) || isAutnq()) {
        <button type="button" (click)="resendDocumentWebhook()" appDropdownItem><i class="fa-regular fa-webhook"></i>{{ 'button.webhookResend' | translate }}</button>
      }
      @if ((isAdmin() || isAutnq()) && !documentService.isMarkdownDocument(document) && !document?.is_dynamic_document) {
        <hr class="dropdown-divider" />
      }
      @if (pdfViewer?.pagesCount() > 0 && !documentService.isPastLifecycle(document) && !documentService.isMarkdownDocument(document)) {
        <label class="dropdown__item-switch">
          <span>{{ 'documents.renderInBrowser' | translate }}</span>
          <app-switch [(ngModel)]="pdfViewer.renderOnIframe"></app-switch>
        </label>
      }
      @if (isAutnq()) {
        <hr class="dropdown-divider" />
        <button type="button" class="dropdown__item--danger" (click)="logout()" appDropdownItem><i class="fa-regular fa-sign-out"></i>{{ 'documents.logoutOfAccount' | translate }}</button>
      }
    </div>

    <div id="document-dropdown-submenu1" appDropdownSubmenu="document-dropdown-submenu1">
      <button type="button" appDropdownBackButton>{{ 'button.back' | translate }}</button>
      <a
        class="dropdown__item--descriptive dropdown__item--description-border-bottom"
        [href]="documentService.signedDocumentUrl(document)"
        [disabled]="!documentService.isSignedOnce(document)"
        target="_blank"
        appDropdownItem
      >
        <i [class]="document.qualified || hasMixedSignature() ? 'fa-regular fa-print' : 'fa-regular fa-file-contract'"></i>
        <div>
          <span class="dropdown__item-title">{{ (document.qualified || hasMixedSignature() ? 'documents.printPDF' : 'documents.signedPDF') | translate }}</span>
          <span class="dropdown__item-description" [innerHTML]="(document.qualified || hasMixedSignature() ? 'documents.printPDFDescription' : 'documents.signedPDFDescription') | translate"></span>
        </div>
      </a>
      @if (!document.qualified) {
        <a
          class="dropdown__item--descriptive dropdown__item--description-border-bottom"
          [href]="document.files?.certified"
          [disabled]="!documentService.isSignedOnce(document)"
          target="_blank"
          appDropdownItem
        >
          <i class="fa-regular fa-file-certificate"></i>
          <div>
            <span class="dropdown__item-title">{{ 'documents.sealedPDF' | translate }}</span>
            <span class="dropdown__item-description" [innerHTML]="'documents.sealedPDFDescription' | translate"></span>
          </div>
        </a>
      }
      @if (document.qualified || hasMixedSignature()) {
        <a
          class="dropdown__item--descriptive dropdown__item--description-border-bottom"
          [href]="documentService.padesDocumentUrl(document)"
          [disabled]="!documentService.isSignedOnce(document)"
          target="_blank"
          appDropdownItem
        >
          <i class="fa-regular fa-file-code"></i>
          <div>
            <span class="dropdown__item-title">{{ 'documents.padesFile' | translate }}</span>
            <span class="dropdown__item-description" [innerHTML]="'documents.padesFileDescription' | translate"></span>
          </div>
        </a>
      }
      <a class="dropdown__item--descriptive" href="javascript:void(0)" (click)="documentService.downloadFile(document)" [disabled]="!document.files?.original" appDropdownItem>
        <i class="fa-regular fa-file-alt"></i>
        <div>
          <span class="dropdown__item-title">{{ 'documents.originalFile' | translate }}</span>
          <span class="dropdown__item-description" [innerHTML]="'documents.originalFileDescription' | translate"></span>
        </div>
      </a>
    </div>

    <div id="document-dropdown-submenu3" appDropdownSubmenu="document-dropdown-submenu3">
      <button type="button" appDropdownBackButton>{{ 'button.back' | translate }}</button>
      @if (!document.is_dynamic_document) {
        <a [routerLink]="['/documentos', document.id, 'campos']" class="dropdown__item--descriptive dropdown__item--description-border-bottom" appDropdownItem>
          <i class="fal fa-money-check-edit"></i>
          <div>
            <span class="dropdown__item-title">{{ 'documents.changeFields' | translate }}</span>
            <span
              class="dropdown__item-description"
              [innerHTML]="'documents.' + (document.qualified ? 'changeAddRemoveSignatureFields' : 'changeAddRemoveSignatureFieldsAndInitials') | translate"
            ></span>
          </div>
        </a>
      }
      <button type="button" class="dropdown__item--descriptive dropdown__item--description-border-bottom" (click)="openCreateSignerModal()" appDropdownItem>
        <i class="fal fa-user-plus"></i>
        <div>
          <span class="dropdown__item-title">{{ 'documents.addSignatory' | translate }}</span>
          <span class="dropdown__item-description" [innerHTML]="'documents.addNewSignatoryByEmailOrLink' | translate"></span>
        </div>
      </button>
      <a [routerLink]="['/documentos', document.id, 'editar']" class="dropdown__item--descriptive" appDropdownItem>
        <i class="fa-regular fa-edit"></i>
        <div>
          <span class="dropdown__item-title">{{ 'documents.changeAdvancedOptions' | translate }}</span>
          <span class="dropdown__item-description" [innerHTML]="'documents.changeAdvancedOptionsDescription' | translate"></span>
        </div>
      </a>
    </div>
  </div>
</ng-template>

<ng-template #documentDropdownTemplateMobile>
  <div (click)="isShowingMobileMenu = true" class="document-mobile__menu-toggle" [class.invisible]="isShowingSignersMobile || isShowingHistoryMobile"><i class="fal fa-bars"></i></div>
  <div
    (click)="isShowingMobileMenu = false; isShowingMobileMenuDownloads = false; isShowingMobileMenuAlteration = false"
    class="document-mobile__menu-overlay"
    [class.visible]="isShowingMobileMenu"
  ></div>
  <div class="document-mobile__menu" [class.visible]="isShowingMobileMenu">
    <div class="group" *ngIf="(pdfViewer?.pagesCount() > 0 || documentService.isMarkdownDocument(document)) && canBeSigned()">
      <div class="group__title">{{ 'documents.actions' | translate }}</div>
      <div class="group__options">
        <button class="group__option" [disabled]="isLoading" (click)="signDocumentPrompt()" *ngIf="documentService.isSignerTurn(document, currentSigners[0])">
          <div class="group__option-icon"><i class="fa-regular fa-feather-alt"></i></div>
          <div class="group__option-name">
            {{ 'signature.signActionDocument.' + ((currentSigners[0].action && currentSigners[0].action.name) || 'SIGN' | lowercase) | translate }}
          </div>
        </button>
        <button class="group__option" *ngIf="document.refusable && documentService.isSignerTurn(document, currentSigners[0])" (click)="rejectDocumentPrompt()">
          <div class="group__option-icon" style="font-size: 22px"><i class="fal fa-times"></i></div>
          <div class="group__option-name">{{ 'documents.rejectTheDocument' | translate }}</div>
        </button>
      </div>
    </div>

    <div class="group">
      <div class="group__title">{{ 'documents.organization' | translate }}</div>
      <div class="group__options">
        <div class="group__option" (click)="isShowingSignersMobile = true; isShowingMobileMenu = false; changeSidebarContainer('signers')">
          <div class="group__option-icon"><i class="fa-regular fa-feather-alt"></i></div>
          <div class="group__option-name">{{ 'documents.signatories' | translate }}</div>
        </div>
        <div class="group__option" (click)="isShowingHistoryMobile = true; isShowingMobileMenu = false; changeSidebarContainer('history')">
          <div class="group__option-icon"><i class="fal fa-history"></i></div>
          <div class="group__option-name">{{ 'documents.history' | translate }}</div>
        </div>
        <div class="group__option" [class.disabled]="documentService.isPastLifecycle(document)" (click)="isShowingMobileMenuDownloads = !documentService.isPastLifecycle(document)">
          <div class="group__option-icon"><i class="fal fa-cloud-download"></i></div>
          <div class="group__option-name">{{ 'documents.downloadFiles' | translate }}</div>
        </div>
        <button class="group__option" *ngIf="isAdmin() || isAutnq()" (click)="isShowingMobileMenu = false; $any($event.target).classList.add('disabled'); resendSignatures()">
          <div class="group__option-icon"><i class="fa-regular fa-undo"></i></div>
          <div class="group__option-name">{{ 'documents.resendToSignatories' | translate }}</div>
        </button>
        <div class="group__option" *ngIf="isAdmin()" (click)="isShowingMobileMenuAlteration = true">
          <div class="group__option-icon"><i class="fa-regular fa-edit"></i></div>
          <div class="group__option-name">{{ 'documents.change' | translate }}</div>
        </div>
        <div class="group__option" *ngIf="isAdmin()" (click)="isShowingMobileMenu = false; toggleBlock()">
          <div class="group__option-icon"><i class="fa-regular fa-{{ documentService.isPastDeadline(document) ? 'lock-open' : 'lock' }}"></i></div>
          <div class="group__option-name">{{ 'documents.' + (documentService.isPastDeadline(document) ? 'unblock' : 'block') | translate }}</div>
        </div>
        <div class="group__option" *ngIf="isAdmin() && documentService.isAllowedToDelete(currentUser, document)" (click)="isShowingMobileMenu = false; deleteDocument()">
          <div class="group__option-icon"><i class="fa-regular fa-trash"></i></div>
          <div class="group__option-name">{{ 'button.exclude' | translate }}</div>
        </div>
      </div>
    </div>

    <div class="group" *ngIf="isAdmin() || isAutnq()">
      <div class="group__title">{{ 'documents.others' | translate }}</div>
      <div class="group__options">
        <div class="group__option" (click)="clearPdfCache(); isShowingMobileMenu = false">
          <div class="group__option-icon"><i class="fa-regular fa-sync"></i></div>
          <div class="group__option-name">{{ 'documents.syncPDFData' | translate }}</div>
        </div>
      </div>
    </div>

    <div class="group" *ngIf="enterpriseService.hideForEnterprise()">
      <div class="group__title">{{ 'documents.accountOptions' | translate }}</div>
      <div class="group__options">
        <div class="group__option" routerLink="/menu/configuracoes">
          <div class="group__option-icon"><i class="fal fa-cog"></i></div>
          <div class="group__option-name">{{ 'documents.settings' | translate }}</div>
        </div>
        <div class="group__option" *ngIf="isAutnq()" (click)="logout()">
          <div class="group__option-icon"><i class="fa-regular fa-sign-out"></i></div>
          <div class="group__option-name">{{ 'documents.logout' | translate }}</div>
        </div>
      </div>
    </div>

    <div
      (click)="isShowingMobileMenuDownloads = false; isShowingMobileMenuAlteration = false"
      class="document-mobile__menu-overlay"
      [class.visible]="isShowingMobileMenuDownloads || isShowingMobileMenuAlteration"
    ></div>
    <div class="document-mobile__menu document-mobile__menu--secondLevel" [class.visible]="isShowingMobileMenuDownloads">
      <div class="group">
        <div class="group__title">{{ 'documents.downloadFiles' | translate }}</div>
        <div class="group__options">
          <a class="group__option" [href]="documentService.signedDocumentUrl(document)" [class.disabled]="!documentService.isSignedOnce(document)" target="_blank">
            <div class="group__option-icon"><i [class]="document.qualified || hasMixedSignature() ? 'fa-regular fa-print' : 'fa-regular fa-file-contract'"></i></div>
            <div class="group__option-name">
              {{ (document.qualified || hasMixedSignature() ? 'documents.printPDF' : 'documents.signedPDF') | translate }} <br />
              <span class="group__option-description">{{ (document.qualified || hasMixedSignature() ? 'documents.printPDFDescription' : 'documents.signedPDFDescription') | translate }}</span>
            </div>
          </a>
          @if (!document.qualified) {
            <a class="group__option" [href]="document.files?.certified" [class.disabled]="!documentService.isSignedOnce(document)" target="_blank">
              <div class="group__option-icon"><i class="fa-regular fa-file-certificate"></i></div>
              <div class="group__option-name">
                {{ 'documents.sealedPDF' | translate }}<br />
                <span class="group__option-description">{{ 'documents.sealedPDFDescription' | translate }}</span>
              </div>
            </a>
          }
          @if (document.qualified || hasMixedSignature()) {
            <a class="group__option" [href]="documentService.padesDocumentUrl(document)" [class.disabled]="!documentService.isSignedOnce(document)" target="_blank">
              <div class="group__option-icon"><i class="fa-regular fa-file-code"></i></div>
              <div class="group__option-name">
                {{ 'documents.padesFile' | translate }}<br />
                <span class="group__option-description">{{ 'documents.padesFileDescription' | translate }}</span>
              </div>
            </a>
          }
          <a class="group__option" href="javascript:void(0)" (click)="documentService.downloadFile(document)" [class.disabled]="!document.files?.original">
            <div class="group__option-icon"><i class="fa-regular fa-file-alt"></i></div>
            <div class="group__option-name">
              {{ 'documents.originalFile' | translate }}<br />
              <span class="group__option-description">{{ 'documents.originalFileDescription' | translate }}</span>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="document-mobile__menu document-mobile__menu--secondLevel" [class.visible]="isShowingMobileMenuAlteration">
      <div class="group">
        <div class="group__title">{{ 'documents.change' | translate }}</div>
        <div class="group__options">
          <a class="group__option" [routerLink]="['/documentos', document.id, 'campos']">
            <div class="group__option-icon"><i class="fal fa-money-check-edit"></i></div>
            <div class="group__option-name">
              {{ 'documents.changeFields' | translate }} <br />
              <span class="group__option-description">{{ 'documents.' + (document.qualified ? 'changeAddRemoveSignatureFields' : 'changeAddRemoveSignatureFieldsAndInitials') | translate }}</span>
            </div>
          </a>
          <button class="group__option" (click)="openCreateSignerModal()">
            <div class="group__option-icon"><i class="fal fa-user-plus"></i></div>
            <div class="group__option-name">
              {{ 'documents.addSignatory' | translate }} <br />
              <span class="group__option-description">{{ 'documents.addNewSignatoryByEmailOrLink' | translate }}</span>
            </div>
          </button>
          <a class="group__option" [routerLink]="['/documentos', document.id, 'editar']">
            <div class="group__option-icon"><i class="fa-regular fa-edit"></i></div>
            <div class="group__option-name">
              {{ 'documents.changeAdvancedOptions' | translate }} <br />
              <span class="group__option-description">{{ 'documents.changeAdvancedOptionsDescription' | translate }}</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-template>
